import { useState } from 'preact/hooks';
import { SlidersHorizontal } from 'lucide-preact';
import { Button } from '@/components/primitives';
import { Drawer } from '@/components/overlays';
import { useBreakpoint } from '@/hooks/useMediaQuery';
import {
  pageFilterCount,
  pageFilterGroups,
  pageFilterNode,
  pageFilterNodesVersion,
} from '@/stores/pageFilters';

/** Single filters entry of the page on a phone; nothing renders if no group registered. */
export function PageFiltersButton() {
  const inline = useBreakpoint('md');
  const groups = pageFilterGroups.value;
  const count = pageFilterCount.value;
  const [open, setOpen] = useState(false);
  // Solo con el panel abierto se siguen los cambios de los controles.
  if (open) void pageFilterNodesVersion.value;

  if (inline || groups.length === 0) return null;

  return (
    <>
      <Button
        size="sm"
        variant={count > 0 ? 'primary' : 'default'}
        leftIcon={SlidersHorizontal}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
      >
        Filtros{count > 0 ? ` · ${count}` : ''}
      </Button>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        side="bottom"
        title="Filtros"
        description="Se aplican a los datos de esta página."
        footer={
          <Button variant="primary" className="w-full" onClick={() => setOpen(false)}>
            Ver resultados
          </Button>
        }
      >
        <div className="flex flex-col gap-6">
          {groups.map((group) => (
            <section key={group.id} className="flex flex-col gap-3">
              <h3 className="text-fg-strong text-13 font-semibold">{group.title}</h3>
              <div className="flex flex-col gap-3 [&_.w-52]:w-full [&_.w-56]:w-full [&_.w-60]:w-full">
                {open ? pageFilterNode(group.id, group.node) : null}
              </div>
            </section>
          ))}
        </div>
      </Drawer>
    </>
  );
}
